module.exports = __webpack_public_path__ + "img/imgSrc22.f17cbb14.png";